import { Component } from '@angular/core';
import * as qs from 'query-string';
import { amorphicStatic } from '@haventech/amorphic';
import { FormBuilder } from '@angular/forms';
import { ModalType } from '../../../../../coverpath-common/js/interfaces/CoverpathTypes';
import { ModalService } from '../../../../../coverpath-common/angular/services/modal/modal.service';
import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { InsuredEsignComponent } from '../esign/insured-esign.component';
import { UICategory, UILoggerSingleton } from '../../../../../common/js/logger/UILoggerSingleton';

@Component({
  moduleId: module.id,
  selector: 'view-documents',
  templateUrl: '../esign/insured-esign.component.html',
})
export class ViewDocumentsComponent extends InsuredEsignComponent {
  constructor(formBuilder: FormBuilder, amorphicService: AmorphicService, modalService: ModalService) {
    super(formBuilder, amorphicService, modalService);
  }

  async ngOnInit() {
    this.validateDocumentAccessForm = this.formBuilder.group({
      SSN: [''],
      attemptsRemaining: [''],
    });
    const parsed = qs.parse(location.search);
    this.validateDocumentAccessData = await this.controller.validateViewDocumentsUrl(parsed.jwtToken);
    this.setAttemptsRemaining(this.validateDocumentAccessData.attemptsRemaining);
    this.loadingScreen = false;
  }

  async validateSSN() {
    this.loadingScreen = true;
    const { documents, attemptsRemaining } = await this.controller.validateSSNAndGetDocsToView(
      this.validateDocumentAccessData.polno,
      this.validateDocumentAccessForm.get('SSN').value,
      this.validateDocumentAccessData.recipient
    );
    this.setAttemptsRemaining(attemptsRemaining);

    if (documents && documents.length) {
      const modalConfig = {
        type: ModalType.esignModal,
        formsToSign: this.setupDocumentsToBeSigned(documents),
        hideEsignButton: true,
        isViewPolicy: true,
        onFinishSigning: async () => {
          const success = await this.controller.insuredEsignComplete(
            qs.parse(location.search).jwtToken,
            this.validateDocumentAccessData.polno
          );
          if (success) {
            this.validateDocumentAccessData.esignCompleted = true;
            UILoggerSingleton.getInstance().info(
              {
                module: 'ViewDocumentsComponent',
                function: 'onFinishSigning',
                category: UICategory.milestone,
              },
              'Insured finished signing'
            );
          } else {
            this.validateDocumentAccessData.isValid = false;
            UILoggerSingleton.getInstance().info(
              {
                module: 'ViewDocumentsComponent',
                function: 'onFinishSigning',
                category: UICategory.milestone,
              },
              'Insured did not complete eSign due to invalid token or policyNumber'
            );
          }
        },
      };
      await this.modalService.activate(modalConfig);
    } else {
      this.validateDocumentAccessForm.get('attemptsRemaining').setErrors({
        max: attemptsRemaining,
      });
      UILoggerSingleton.getInstance().error(
        {
          module: 'ViewDocumentsComponent',
          function: 'validateSSN',
          category: UICategory.milestone,
        },
        'No attempts remaining'
      );
    }

    this.loadingScreen = false;
  }

  setupDocumentsToBeSigned(documentsToBeSigned) {
    const viewApplicationDocumentSetup = {
      formType: 'Application',
      pdfUrl: this.controller.getApplicationPdfURL(),
      textPrompt: `Take a minute to make sure everything looks right. If you need to update anything, contact your financial professional. You can leave this page when you're done.`,
      signFn: async () => {
        UILoggerSingleton.getInstance().info(
          {
            module: 'ViewDocumentsComponent',
            function: 'signFn',
            category: UICategory.milestone,
          },
          'Insurability form signed'
        );
      },
    };

    const result = [];
    if (documentsToBeSigned.includes('Application')) {
      result.push(viewApplicationDocumentSetup);
    }

    return result;
  }

  close(): void {
    window.close();
  }
}
